import React, { useState, useEffect } from "react";
import {
  CardContent,
  CardActions,
  Card,
  Grid,
  Typography,
  Box, 
  Avatar, 
  IconButton,
  Container,
  Stack,
  Divider,
  Fade,
  Zoom,
  Paper,
  Chip
} from "@mui/material";
import { 
  AccountBalance, 
  AccountBalanceWallet,
  QrCode,
  ContentCopy,
  CheckCircle
} from '@mui/icons-material';
const Bankdetails = () => {
  const [copiedField, setCopiedField] = useState(null);

  const bankDetails = [
    {
      id: 1,
      bankName: "IDFC FIRST BANK",
      accountName: "PERFECT LAYOUT PRIVATE LIMITED",
      accountNumber: "10154471583",
      ifscCode: "IDFB0080218",
      color: "#1976d2"
    },
    {
      id: 2,
      bankName: "AXIS BANK",
      accountName: "PERFECT LAYOUT PRIVATE LIMITED", 
      accountNumber: "923020028189536",
      ifscCode: "UT1B0004272",
      color: "#ff9800"
    }
  ];

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2000);
  };

  return (
    <Container sx={{ m: 0, width: '100%', maxWidth: '100%' }} maxWidth={false}>
      {/* Professional Header Section */}
      <Fade in timeout={800}>
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
            <Avatar sx={{ 
              bgcolor: '#1976d2', 
              width: 48, 
              height: 48,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
            }}>
              <AccountBalanceWallet sx={{ fontSize: 24, color: 'white' }} />
            </Avatar>
            <Box>
            <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
              Bank Details
            </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Company banking information and payment methods
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ my: 2 }} />
        </Box>
      </Fade>

      {/* Bank Details Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {bankDetails.map((bank, index) => (
          <Grid item xs={12} md={6} key={bank.id}>
            <Zoom in timeout={1000 + (index * 200)}>
              <Card elevation={4} sx={{ 
                borderRadius: 3,
                overflow: 'hidden',
                boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                height: '100%'
              }}>
                {/* Bank Header */}
                <Box sx={{ 
                  p: 3, 
                  background: `linear-gradient(135deg, ${bank.color} 0%, ${bank.color}dd 100%)`,
                  color: 'white'
                }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar sx={{ 
                      bgcolor: 'rgba(255,255,255,0.2)', 
                      width: 48, 
                      height: 48 
                    }}>
                      <AccountBalance sx={{ fontSize: 24, color: 'white' }} />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" fontWeight="bold">
                        {bank.bankName}
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Corporate Account
                      </Typography>
                    </Box>
                  </Stack>
                </Box>

                {/* Bank Details */}
                <CardContent sx={{ p: 3 }}>
                  <Stack spacing={2}>
                    <Box>
                      <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ mb: 0.5 }}>
                        Account Holder Name
                      </Typography>
                      <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        p: 1.5,
                        backgroundColor: '#f8f9fa',
                        borderRadius: 2,
                        border: '1px solid #e9ecef'
                      }}>
                        <Typography variant="body1" fontWeight="500">
                          {bank.accountName}
                        </Typography>
                        <IconButton 
                          size="small" 
                          onClick={() => copyToClipboard(bank.accountName, `account-${bank.id}`)}
                          sx={{ color: '#1976d2' }}
                        >
                          {copiedField === `account-${bank.id}` ? <CheckCircle /> : <ContentCopy />}
                        </IconButton>
                      </Box>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ mb: 0.5 }}>
                        Account Number
                      </Typography>
                      <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        p: 1.5,
                        backgroundColor: '#f8f9fa',
                        borderRadius: 2,
                        border: '1px solid #e9ecef'
                      }}>
                        <Typography variant="body1" fontWeight="500" fontFamily="monospace">
                          {bank.accountNumber}
                        </Typography>
                        <IconButton 
                          size="small" 
                          onClick={() => copyToClipboard(bank.accountNumber, `number-${bank.id}`)}
                          sx={{ color: '#1976d2' }}
                        >
                          {copiedField === `number-${bank.id}` ? <CheckCircle /> : <ContentCopy />}
                        </IconButton>
                      </Box>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ mb: 0.5 }}>
                        IFSC Code
                      </Typography>
                      <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        p: 1.5,
                        backgroundColor: '#f8f9fa',
                        borderRadius: 2,
                        border: '1px solid #e9ecef'
                      }}>
                        <Typography variant="body1" fontWeight="500" fontFamily="monospace">
                          {bank.ifscCode}
                        </Typography>
                        <IconButton 
                          size="small" 
                          onClick={() => copyToClipboard(bank.ifscCode, `ifsc-${bank.id}`)}
                          sx={{ color: '#1976d2' }}
                        >
                          {copiedField === `ifsc-${bank.id}` ? <CheckCircle /> : <ContentCopy />}
                        </IconButton>
                      </Box>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Zoom>
          </Grid>
        ))}
      </Grid>

      {/* UPI QR Code Section */}
      <Fade in timeout={1400}>
        <Box>
          <Zoom in timeout={1600}>
            <Card elevation={4} sx={{ 
              borderRadius: 3,
              overflow: 'hidden',
              boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
              maxWidth: 400,
              mx: 'auto'
            }}>
              {/* QR Header */}
              <Box sx={{ 
                p: 3, 
                background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                color: 'white',
                textAlign: 'center'
              }}>
                <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
                  <Avatar sx={{ 
                    bgcolor: 'rgba(255,255,255,0.2)', 
                    width: 48, 
                    height: 48 
                  }}>
                    <QrCode sx={{ fontSize: 24, color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold">
                      UPI Payment
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                      Quick & Easy Payments
                    </Typography>
                  </Box>
                </Stack>
              </Box>

              {/* QR Code */}
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Box sx={{ 
                  p: 2, 
                  backgroundColor: '#f8f9fa',
                  borderRadius: 3,
                  border: '2px solid #e9ecef',
                  display: 'inline-block',
                  mb: 2
                }}>
                  <img
                    srcSet={`https://perfectlayoutdata.s3.ap-south-1.amazonaws.com/data/PerfectlayoutQR.jpg`}
                    src={`https://perfectlayoutdata.s3.ap-south-1.amazonaws.com/data/PerfectlayoutQR.jpg`}
                    alt={'UPI QR Code'}
                    width={300}
                    height={400}
                    loading="lazy"
                    style={{ borderRadius: '8px' }}
                  />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ 
                  backgroundColor: '#e3f2fd',
                  p: 2,
                  borderRadius: 2,
                  border: '1px solid #bbdefb'
                }}>
                  <strong>How to Pay:</strong> Scan this QR code using any UPI app (PhonePe, Google Pay, Paytm, etc.)
                </Typography>
              </CardContent>
            </Card>
          </Zoom>
        </Box>
      </Fade>

      {/* Professional Stats Footer */}
      <Fade in timeout={1800}>
        <Box sx={{ mt: 4 }}>
          <Paper elevation={2} sx={{ 
            p: 3, 
            borderRadius: 3,
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef'
          }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ 
                    bgcolor: '#1976d2', 
                    width: 40, 
                    height: 40 
                  }}>
                    <AccountBalance sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      {bankDetails.length}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Bank Accounts
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ 
                    bgcolor: '#28a745', 
                    width: 40, 
                    height: 40 
                  }}>
                    <QrCode sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      UPI
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Payment Method
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ 
                    bgcolor: '#ffc107', 
                    width: 40, 
                    height: 40 
                  }}>
                    <CheckCircle sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      Secure
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Banking
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Fade>
    </Container>
  )
};

export default Bankdetails;
